import { render, staticRenderFns } from "./device-info.vue?vue&type=template&id=0b397da2"
import script from "./device-info.vue?vue&type=script&lang=js"
export * from "./device-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports